import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-professionnel-dossiers-card-list",
  templateUrl: "./dossiers-card-list.component.html",
  styleUrls: ["./dossiers-card-list.component.scss"]
})
export class DossiersCardListComponent implements OnInit {
  isListView = false; // Variable pour gérer le composant visible
  constructor() {}

  ngOnInit() {
    this.isListView = false;
  }
  toggleComponent(view: string) {
    if (view === "grid") this.isListView = false;
    // Toggle
    else this.isListView = true;
  }
}
